import { render, staticRenderFns } from "./modifyPrice.vue?vue&type=template&id=131513a2&scoped=true"
import script from "./modifyPrice.vue?vue&type=script&lang=js"
export * from "./modifyPrice.vue?vue&type=script&lang=js"
import style0 from "./modifyPrice.vue?vue&type=style&index=0&id=131513a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131513a2",
  null
  
)

export default component.exports